module.exports = __webpack_public_path__ + "static/media/special_5.42d34131.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_5.csv
// module id = 741
// module chunks = 0